module.exports = __webpack_public_path__ + "plugins/jquery.loader/img/jquery.loader.gif";


//////////////////
// WEBPACK FOOTER
// ./plugins/jquery.loader/img/jquery.loader.gif
// module id = 160
// module chunks = 2 3 7 8 11 21 22 23 40 41 43 44 45 47 48 49 51